import { createAction, props } from '@ngrx/store';

export const loadAccountSelection = createAction('[App Init] Load Account Selection');

export const setSelectedAccount = createAction(
  '[Account Selection] Set Selected Account',
  props<{ displayAccount: string }>(),
);

export const setSelectedAddress = createAction(
  '[Account Selection] Set Selected Address',
  props<{ displayAddress: string }>(),
);
